/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Vk = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="m21.579 6.85507c.14-.465 0-.806-.662-.806h-2.193c-.558 0-.813.295-.953.619 0 0-1.115 2.719-2.695 4.48203-.51.513-.743.675-1.021.675-.139 0-.341-.162-.341-.627v-4.34303c0-.558-.161-.806-.626-.806h-3.446c-.348 0-.558.258-.558.504 0 .528.79.65.871 2.138v3.22803c0 .707-.127.836-.407.836-.743 0-2.551-2.729-3.624-5.85303-.209-.607-.42-.852-.98-.852h-2.192c-.627 0-.752.295-.752.619 0 .582.743 3.46203 3.461 7.27103 1.812 2.601 4.363 4.011 6.687 4.011 1.393 0 1.565-.313 1.565-.853v-1.966c0-.626.133-.752.574-.752.324 0 .882.164 2.183 1.417 1.486 1.486 1.732 2.153 2.567 2.153h2.192c.626 0 .939-.313.759-.931-.197-.615-.907-1.51-1.849-2.569-.512-.604-1.277-1.254-1.51-1.579-.325-.419-.231-.604 0-.976.001.001 2.672-3.76103 2.95-5.04003z"
    />
  </Icon>
);
